import React, { Component } from 'react'

export default class Logo extends Component {
  constructor(props) {    
    super(props)
  }

  render() {
    const logo =  this.props.registrationPagesLogoImage != null ? this.props.registrationPagesLogoImage : "https://start.newtopia.com/registration/Pages/header_logo_Newtopia.png"
    return (
      <span>
        <img className="logo" tabindex="0" src={logo} alt="Logo" />
      </span>
    )
  }
}